import { createFileRoute } from '@tanstack/react-router'

import { requireSession } from '@/modules/auth'
import { TrialWelcomePage } from '@/modules/getting-started'

export const Route = createFileRoute('/trial_/welcome')({
  staticData: { title: 'Welcome' },
  beforeLoad: requireSession,
  component: TrialWelcomePage,
})
